import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { getDynamicImage, SERIES_DETAIL_HERO_IMAGE } from 'helpers/ImageHelper';

import {
  SITE_PLATFORM_WEB_LARGE,
  SITE_PLATFORM_WEB,
  SITE_PLATFORM_TABLET,
  SITE_PLATFORM_MOBILE,
  isMobileBreakpoint,
} from 'helpers/BreakpointHelper';
import Style from './Background.module.scss';

const BREAKPOINTS = {
  [SITE_PLATFORM_WEB_LARGE]: {
    imageSrc: 'images.seriesDetail.raw',
    altText: 'images.seriesDetail.altText',
  },
  [SITE_PLATFORM_WEB]: {
    imageSrc: 'images.seriesDetail.raw',
    altText: 'images.seriesDetail.altText',
  },
  [SITE_PLATFORM_TABLET]: {
    imageSrc: 'images.seriesDetail.raw',
    altText: 'images.seriesDetail.altText',
  },
  [SITE_PLATFORM_MOBILE]: {
    imageSrc: 'images.keyart_tablet_landscape.raw',
    altText: 'images.keyart_tablet_landscape.altText',
  },
};

const Background = ({ item = {}, breakpoint = SITE_PLATFORM_WEB }) => {
  const { imageSrc, altText } = BREAKPOINTS[breakpoint];
  useEffect(() => {
    const backgroundImage = document.getElementById('backgroundImage');
    let opacity = 1;
    let transformY;

    const opacityChange = () => {
      const yScrollPosition = window.scrollY;

      const currScrollPos2 =
        window.scrollY || document.documentElement.scrollTop || document.body.scrollTop || 0;
      if (currScrollPos2 <= 500) {
        opacity = (-currScrollPos2 * 0.75) / 500 + 1;
      } else {
        opacity = 0.25;
      }

      transformY = yScrollPosition * 0.2;

      const css = (element, styles) => {
        const el = element;
        Object.keys(styles).forEach(key => {
          el.style[key] = styles[key];
        });
      };

      const setTransformY = `translateY(${transformY}px)`;
      css(backgroundImage, { opacity, transform: setTransformY });
      requestAnimationFrame(opacityChange);
    };

    window.addEventListener('scroll', opacityChange);
    return () => {
      window.removeEventListener('scroll', opacityChange);
    };
  }, []);
  const name = _.get(item, 'name');
  const image = _.get(item, imageSrc);
  const alt = _.get(item, altText, name);

  const isMobile = isMobileBreakpoint(breakpoint);

  const fallbackImage = isMobile
    ? _.get(item, 'images.still.raw') ||
      _.get(item, 'images.seriesDetail.raw') ||
      _.get(item, 'images.seriesList.raw')
    : _.get(item, 'images.seriesList.raw') || _.get(item, 'images.still.raw');
  const url = image || fallbackImage;
  const backgroundImage = getDynamicImage({ breakpoint, context: SERIES_DETAIL_HERO_IMAGE, url });
  return (
    <div className={Style.background} id="backgroundImage">
      <img src={backgroundImage} alt={alt} />
    </div>
  );
};

Background.propTypes = {
  item: PropTypes.shape({}),
  breakpoint: PropTypes.string.isRequired,
};
export default Background;
